import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { downGradeOfferModalSxs } from '../newChangePlan';
import { downGradeOfferModalTexts, paths } from 'src/common/config/TextMessage';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';

import { useState } from 'react';
import {
  downgradeDeactivateOffers,
  getAddonDetails,
  getSubscriptionDetailsStripe
} from 'src/common/Scraper';
import CommonAlert from 'src/common/CommonAlert';
import {
  setAddonDetails,
  setScanDetails,
} from 'src/redux/counterSlice';
import {
  isLocalSeoUser,
  setProgressCalculation
} from 'src/common/config/FunctionHelper';
import { setStateStripeSubscription } from 'src/redux/userReducer';
import { useNavigate } from 'react-router';
import { setOfferApplied } from 'src/redux/dashboard';
import { useUserDetails } from 'src/hooks/apiHooks/useUserDetails';

export const PreferMonthlyBilling = ({
  selectedTimeLine = '',
  handCloseModal = () => {},
  handleChangePlanModal = () => {},
  isFromDeactivate = false,
  setIsOfferApplied
}) => {
  const [loading, setLoading] = useState(null);
  const [responseMessage, setResponseMessage]: any = useState(null);
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  const { refetch: refetchUserDetails } = useUserDetails({ enabled: false });
  const isAgency = activePlanName === planDetails?.agency;
  const isExpertPlus = activePlanName === planDetails?.expertPlus;
  const isDiy = activePlanName === planDetails?.diy;
  const isStarterPlus = activePlanName === planDetails?.starterPlus;
  const isProPlan = activePlanName === planDetails?.designer;
  const isLocalSeo = isLocalSeoUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleRedeemOffer = async () => {
    setLoading(true);
    setIsOfferApplied(true);
    const payload = {
      subscriptionId: stripeSubscriptionDetails?.subscription_id,
      selectedDowngradeReason: 'Prefer Monthly Billing',
      planId: stripeSubscriptionDetails?.plan_name?.id
    };
    const downgradeDeactivateOffersResponse: any =
      await downgradeDeactivateOffers(payload);

    setResponseMessage({
      status: downgradeDeactivateOffersResponse?.status,
      message: downgradeDeactivateOffersResponse?.message
    });
    if (downgradeDeactivateOffersResponse?.status == 'success') {
      const subscriptionDetailsStripe = await getSubscriptionDetailsStripe();
      if (subscriptionDetailsStripe != undefined) {
        dispatch(setStateStripeSubscription(subscriptionDetailsStripe));
      } else {
        dispatch(setStateStripeSubscription({}));
      }
      if (isFromDeactivate) {
        const { data: userDetailsResponse } = await refetchUserDetails();
        if (isPremiumUser) {
          // Fetch additional scan details for premium users
          let addonScan = await getAddonDetails();
          let getProgressScore = setProgressCalculation(
            userDetailsResponse,
            addonScan
          );
          dispatch(setScanDetails(getProgressScore));
          dispatch(setAddonDetails(addonScan));
        }
      }
    }
    setTimeout(() => {
      setLoading(false);
      setIsOfferApplied(false);
      setResponseMessage(null);
      if (downgradeDeactivateOffersResponse?.status == 'success') {
        dispatch(setOfferApplied({ open: true, isPreferMonthly: true }));
        navigate(paths?.dashboard);
        handCloseModal();
        handleChangePlanModal();
      }
    }, 3000);
  };
  return (
    <>
      <Typography sx={downGradeOfferModalSxs?.offerCardHeadTextSx}>
        {downGradeOfferModalTexts?.preferMonthlyOffer}
      </Typography>
      <Typography sx={downGradeOfferModalSxs?.offerCardDescTextSx}>
        {downGradeOfferModalTexts?.preferMonthlyDesc}
        {isDiy || isStarterPlus
          ? ' $14.99/month.'
          : isProPlan
          ? '$39.99/month.'
          : isAgency || isExpertPlus
          ? '$99.99/month'
          : isLocalSeo
          ? '$39.99/mo'
          : ''}
      </Typography>
      {responseMessage?.status && (
        <Box className="mt-1">
          <CommonAlert
            severity={responseMessage?.status}
            message={responseMessage?.message}
          />
        </Box>
      )}
      <Button
        variant="contained"
        fullWidth
        sx={downGradeOfferModalSxs?.offerCardBtnSx}
        onClick={handleRedeemOffer}
      >
        {loading ? (
          <CircularProgress color="inherit" size={24} />
        ) : (
          downGradeOfferModalTexts?.switchToMonthly
        )}
      </Button>
    </>
  );
};
